<template>
  <div class="wildcard-requirement req">
    <div class="reqinfo">
      <!-- Wildcard Name -->
      <div class="wildcard-name">{{req.name}}</div>

      <!-- Display min and max credit hours -->
      <div class="req-item">Credit Hours:
        <template v-if = 'req.minimum_credits === req.maximum_credits'>
          {{req.minimum_credits}}
        </template>
        <template v-else>
          {{req.minimum_credits}} - {{req.maximum_credits}}
        </template>
      </div>

      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'wildcard',

    // Properties
    // Req - The requirement object
    props: ['req'],

    methods: {
      // used to roll credit count up to parent requirement sets
      computeMinimumCredits() {
        return this.req.minimum_credits
      }
    }
  }
</script>



// WEBPACK FOOTER //
// wild_card_requirement.vue?64683344